import { Fab } from '@mui/material'
import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface BackButtonBaseProps {
  onBack: () => void
}

export const BackButtonBase: React.FC<BackButtonBaseProps> = ({ onBack }) => {
  return (
    <Fab
      onClick={onBack}
      aria-label='Volver'
      variant='extended'
      size='medium'
      style={{
        borderRadius: '12px',
        height: '50px',
        minWidth: '110px',
        paddingLeft: '10px',
        paddingRight: '14px',
        zIndex: 1,
        backgroundColor: 'transparent',
        border: '1px solid #E0E0E0',
        boxShadow: 'none',
        fontSize: '14px',
        fontWeight: 500,
        color: '#666',
        gap: '2px',
        textTransform: 'none',
        cursor: 'pointer'
      }}
    >
      <ArrowBackIcon style={{ fontSize: 18 }} />
      Volver
    </Fab>
  )
}
